import { render, staticRenderFns } from "./ManageLimits.vue?vue&type=template&id=060fa1c3"
import script from "./ManageLimits.vue?vue&type=script&lang=ts"
export * from "./ManageLimits.vue?vue&type=script&lang=ts"
import style0 from "./ManageLimits.vue?vue&type=style&index=0&id=060fa1c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports